module.exports = __webpack_public_path__ + "static/media/blue-tick.acb39b31.svg";